/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import styled from 'styled-components';
import StyledProps from '../../theme/AppThemeInterface';

const ClockWrapper = styled.div`
  opacity: 0.8;
  height: 28px;
  padding-left: 16px;
  color: ${({ theme }: StyledProps) => theme.primaryTextColor};
  font-family: ${({ theme }: StyledProps) => theme.appFontFamily};
  font-size: 14px;
  letter-spacing: 0.41px;
  line-height: 28px;
  text-align: right;

  @media print {
    width: 200px;
    color: black;
  }
`;

export default ClockWrapper;
